// extracted by mini-css-extract-plugin
module.exports =  {"root":"JeDgK4qLl7Q85SOYpY1F","avatar":"xExtIOrKpDvrR6sKDCij","email":"Og4_zgmoDVRHPh5qabwj","name":"GuQ5TLe5pRVbEbIeX6ck","reachable":"GtdnZdiZ0qIK3KksXSCi"};